<template>
  <div>
    <v-dialog
      v-model="showModal"
      max-width="400"
    >
      <v-card
        class="mx-auto"
      >
        <v-toolbar
          color="#37474F"
          dark
        >
          <v-toolbar-title>
            Confirm Location Structure ?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p>This action will confirm and create Location group across your organization.</p>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="showModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red darken-1"
              text
              @click="createConfirmed()"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card
      shaped
      color="#ECEFF1"
    >
      <br>
      <base-tree-view-without-actions
        :value="treeData"
        draggable
        droppable
        class="my-tree-view-style"
      />
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          class="mt-2"
          color="#FF3700"
          @click="create()"
        >
          create
        </v-btn>
      </v-col>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </div>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import { walkTreeData } from 'he-tree-vue';

  export default {
    name: 'GroupLocations',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        treeData: [],
        loading: true,
        showModal: false,
        deleteMessage: '',
      };
    },
    computed: {
      createdStructure () {
        return this.$store.getters['locations/getCreatedLocationStructure'];
      },
      locations () {
        return this.$store.getters['locations/getLocationsList'];
      },
      savedStructure () {
        return this.$store.getters['locations/getSavedLocationStructure'];
      },
    },
    async mounted () {
      this.loading = true;
      await this.$store.dispatch('locations/fetchLocationsList');
      await this.$store.dispatch('locations/fetchSavedLocationStructure');
      this.createLocationTreeList();
      this.loading = false;
    },
    methods: {
      createLocationTreeList () {
        if (Object.keys(this.savedStructure).length <= 0) {
          const locations = this.locations;
          const structure = this.createdStructure;
          for (const location of locations) {
            structure[0].children.push({
              id: location.id,
              text: `${location.name}`,
            });
          }
          this.treeData = structure;
          return;
        }
          this.treeData = this.createdStructure;
            const availabeLocations = [];
            walkTreeData(this.treeData, (node) => {
              if (node.id !== undefined) {
                availabeLocations.push(node.id);
              }
            });
          const newLocations = this.locations.filter(i => !availabeLocations.includes(i.id));
          for (const newLocation of newLocations) {
            this.treeData[0].children.push({
              id: newLocation.id,
              text: `${newLocation.name}`,
            });
          }
      },
      create () {
        if (this.treeData.length > 1 || this.treeData[0].text !== 'All Locations') {
          this.$store.dispatch('alert/onAlert', {
            message: 'All nodes should come under "All Locations".',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.showModal = true;
      },
      async createConfirmed () {
        this.loading = true;
        await this.$store.dispatch('locations/groupLocations', {
          group: this.treeData,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Locations group created successfully',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.showModal = false;
          this.$router.push({ name: 'Locations' });
        }).finally(
          this.loading = false,
          this.showModal = false,
        );
      },
    },
  };
</script>
<style scoped>
.my-tree-view-style {
  margin-left: 30px;
}
</style>
